import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {IAdxErpReportItem} from '../interfaces/adx-erp-panel.interface';
import {AdxErpPanelFilterService} from './adx-erp-panel-filter.service';
import moment from 'moment';
import {Sort} from '@angular/material/sort';

@Injectable({
  providedIn: 'root'
})
export class AdxErpReportGridService implements GridGetService<IAdxErpReportItem> {
  private readonly baseUrl = 'dbov2/adx-invoice/erp-report';
  private readonly http = inject(HttpClient);
  private readonly filterService = inject(AdxErpPanelFilterService);

  getItems({page, sort}: GridServiceParams): Observable<GridServiceResponse<IAdxErpReportItem>> {
    const filters = this.filterService.filtersValue();

    const params: Record<string, string | number | boolean | string[] | number[]> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      propertyName: this.mapSortPropertyName(sort),
      orderKey: sort?.direction || '',
      adxInvoiceId: filters?.AdxInvoiceId ?? '',
      recordLocator: filters?.RecordLocator ?? '',
      erpOrderNumber: filters?.ErpOrderNumber ?? '',
      clientName: filters?.ClientName ?? '',
      createdDateFrom: filters?.CreatedDateFrom ? moment(filters.CreatedDateFrom).format('YYYY-MM-DD') : '',
      createdDateTo: filters?.CreatedDateTo ? moment(filters.CreatedDateTo).format('YYYY-MM-DD') : '',
      erpSentDateFrom: filters?.ErpSentDateFrom ? moment(filters.ErpSentDateFrom).format('YYYY-MM-DD') : '',
      erpSentDateTo: filters?.ErpSentDateTo ? moment(filters.ErpSentDateTo).format('YYYY-MM-DD') : '',
      erpResponseDateFrom: filters?.ErpResponseDateFrom ? moment(filters.ErpResponseDateFrom).format('YYYY-MM-DD') : '',
      erpResponseDateTo: filters?.ErpResponseDateTo ? moment(filters.ErpResponseDateTo).format('YYYY-MM-DD') : '',
      isMor: filters?.IsMor ?? '',
      travelTypeId: filters?.TravelTypeId ?? '',
      externalTravelServiceTypeId: filters?.ExternalTravelServiceTypeId ?? '',
      vendorName: filters?.VendorName ?? '',
      agentName: filters?.AgentName ?? '',
      dataSourceId: filters?.DataSourceId ?? '',
      invoiceGroup: filters?.InvoiceGroup ?? '',
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<IAdxErpReportItem>>(this.baseUrl, {params: {...params}})
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }

  /**
   * Sorting happens over AdxInvoiceErpReportView, so columns the response DTO renames have to be
   * translated back to the view's own property names or the server ignores the sort entirely.
   */
  private mapSortPropertyName(sort?: Partial<Sort>): string {
    if (!sort?.active) return '';
    const propertyNameMap: { [key: string]: string } = {
      'fmsAdxInvoiceId': 'id',
      'adxReference': 'recordLocator',
    };
    return propertyNameMap[sort.active] || sort.active;
  }
}
